import { useQuery } from '@tanstack/react-query'
import { ApiError, api } from '../api/client'

/** Whether the Campaign Desk is on for this account: its settings answer 200. A 404 (desk switched
 *  off) or 403 (not admin/operator) means no; any other failure is thrown and retried, so a network
 *  blip doesn't hide the link. Pass `enabled` false to skip the probe for roles that can't use it. */
export function useCampaignDeskEnabled(enabled: boolean) {
  return useQuery({
    queryKey: ['campaign-desk-enabled'],
    queryFn: () =>
      api.get('/api/campaign-desk/settings').then(
        () => true,
        (err: unknown) => {
          if (err instanceof ApiError && (err.status === 404 || err.status === 403)) return false
          throw err
        },
      ),
    enabled,
    staleTime: 5 * 60 * 1000,
  })
}
